module.exports = __webpack_public_path__ + "img/RORBPJR40050.808e1132.png";